<template>
    <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.06173 12.6667V11V12.6667ZM6.35803 12.6667V9.33333V12.6667ZM8.65432 12.6667V7.66667V12.6667ZM10.1852 16H2.53086C2.12485 16 1.73547 15.8244 1.44838 15.5118C1.16129 15.1993 1 14.7754 1 14.3333V2.66667C1 2.22464 1.16129 1.80072 1.44838 1.48816C1.73547 1.17559 2.12485 1 2.53086 1H6.80657C7.00956 1.00005 7.20422 1.08788 7.34773 1.24417L11.4918 5.75583C11.6353 5.91208 11.716 6.124 11.7161 6.345V14.3333C11.7161 14.7754 11.5548 15.1993 11.2677 15.5118C10.9806 15.8244 10.5912 16 10.1852 16Z"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        <path
            d="M16.6482 12.7777V13.3703"
            stroke="#333333"
            stroke-width="0.85"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        <path
            d="M16.6482 16.6296V17.2222"
            stroke="#333333"
            stroke-width="0.85"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        <path
            d="M16.5 19C18.7091 19 20.5 17.2091 20.5 15C20.5 12.7909 18.7091 11 16.5 11C14.2909 11 12.5 12.7909 12.5 15C12.5 17.2091 14.2909 19 16.5 19Z"
            stroke="#333333"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        <path
            d="M15.4998 16.6296H16.9998C17.2209 16.6296 17.4328 16.5438 17.5891 16.391C17.7454 16.2382 17.8332 16.0309 17.8332 15.8148C17.8332 15.5987 17.7454 15.3915 17.5891 15.2386C17.4328 15.0858 17.2209 15 16.9998 15H15.9998C15.7788 15 15.5669 14.9141 15.4106 14.7613C15.2543 14.6085 15.1665 14.4013 15.1665 14.1852C15.1665 13.9691 15.2543 13.7618 15.4106 13.609C15.5669 13.4562 15.7788 13.3704 15.9998 13.3704H17.4998"
            stroke="#333333"
            stroke-width="0.85"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
    </svg>
</template>
<script>
export default {
    name: 'IconFinanceReports',
};
</script>
